(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logo-marquee')) {
    customElements.define('logo-marquee', class LogoMarquee extends HTMLElement {
      connectedCallback() {
        this.group = this.querySelector('.logo-marquee__group');
        if (!this.group) return;

        // Однакова швидкість (px/s) на будь-якій ширині екрана і з будь-якою кількістю лого
        this.update = this.update.bind(this);
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.group);
        }
        this.update();

        // Не анімуємо, коли секцію не видно
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => this.classList.toggle('is-offscreen', !entry.isIntersecting),
            { rootMargin: '100px 0px' }
          );
          this.io.observe(this);
        }
      }

      disconnectedCallback() {
        this.ro && this.ro.disconnect();
        this.io && this.io.disconnect();
      }

      update() {
        const speed = Math.max(Number(this.dataset.speed) || 50, 1);
        const gap = parseFloat(getComputedStyle(this.group).columnGap) || 0;
        const distance = this.group.offsetWidth + gap;
        if (distance > 0) {
          this.style.setProperty('--lm-duration', (distance / speed).toFixed(2) + 's');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
